export const EXPORT_DATE_FORMATS = ['DD.MM.YYYY', 'MM.DD.YYYY', 'YYYY.MM.DD'] as const;

export type ExportDateFormat = (typeof EXPORT_DATE_FORMATS)[number];

export const getExportDateFormatLabel = (format: string, language: string): string => {
	const isGerman = language === 'de';

	switch (format) {
		case 'DD.MM.YYYY':
			return isGerman ? 'TT.MM.JJJJ' : 'DD.MM.YYYY';
		case 'MM.DD.YYYY':
			return isGerman ? 'MM.TT.JJJJ' : 'MM.DD.YYYY';
		case 'YYYY.MM.DD':
			return isGerman ? 'JJJJ.MM.TT' : 'YYYY.MM.DD';
		default:
			return isGerman ? 'TT.MM.JJJJ' : 'DD.MM.YYYY';
	}
};

export const getExportDateFormatOptions = (language: string) =>
	EXPORT_DATE_FORMATS.map((format) => ({
		label: getExportDateFormatLabel(format, language),
		value: format
	}));

export const normalizeExportDateFormat = (value?: string | null): ExportDateFormat => {
	if (value && EXPORT_DATE_FORMATS.includes(value as ExportDateFormat)) {
		return value as ExportDateFormat;
	}

	return 'DD.MM.YYYY';
};
